/**
 * StatusUnknownIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const StatusUnknownIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2m.93 14.78a1.37 1.37 0 0 1-.91.32 1.35 1.35 0 0 1-.91-.32 1.07 1.07 0 0 1-.36-.83 1 1 0 0 1 .36-.82 1.3 1.3 0 0 1 .89-.33c.334-.01.66.109.91.33a1 1 0 0 1 .36.82 1.07 1.07 0 0 1-.34.83m2.15-6.16c-.186.351-.43.669-.72.94l-.79.73a1.9 1.9 0 0 0-.46.65c-.09.278-.137.568-.14.86H11a4.4 4.4 0 0 1 .22-1.57 2.5 2.5 0 0 1 .73-1 4.5 4.5 0 0 0 .76-.77 1.22 1.22 0 0 0 .29-.77c0-.68-.29-1-.88-1a.83.83 0 0 0-.66.3 1.24 1.24 0 0 0-.26.8H8.9a2.7 2.7 0 0 1 .86-2.11 3.38 3.38 0 0 1 2.36-.76 3.54 3.54 0 0 1 2.35.7 2.47 2.47 0 0 1 .83 2 2.3 2.3 0 0 1-.22 1" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const StatusUnknownIcon = makeIcon('StatusUnknownIcon', StatusUnknownIconSvg)
